/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fund_Please_Wait_While_Our_Team_Sets_This_Up_For_YouInputs */

const en_fund_please_wait_while_our_team_sets_this_up_for_you = /** @type {(inputs: Fund_Please_Wait_While_Our_Team_Sets_This_Up_For_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please wait while our team sets this up for you`)
};

/**
* | output |
* | --- |
* | "Please wait while our team sets this up for you" |
*
* @param {Fund_Please_Wait_While_Our_Team_Sets_This_Up_For_YouInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const fund_please_wait_while_our_team_sets_this_up_for_you = /** @type {((inputs?: Fund_Please_Wait_While_Our_Team_Sets_This_Up_For_YouInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fund_Please_Wait_While_Our_Team_Sets_This_Up_For_YouInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fund_please_wait_while_our_team_sets_this_up_for_you(inputs)
});